<template>

    <div class="imageZoomable">
        <div class="imageZoomable_img" :class="{appearEffect: appearEffect, containDisplay: isContainDisplay}" ref="image" :style="{backgroundPosition: bgPos, backgroundImage: 'url(' + imgPath(src) + ')'}">
        </div>
        <ButtonMagnetic  v-if="!noZoom && !blackButton" color="white" @click.native="zoom"></ButtonMagnetic>
        <ButtonMagnetic  v-if="!noZoom && blackButton" color="black" @click.native="zoom"></ButtonMagnetic>
        <div class="imageZoomable_zoom" @click="unzoom" ref="zoom">
            <img ref="zoom_img" :src="imgPath(src)" alt="" :style="{'object-position': bgPos}" />
            <Caption :title="caption" v-if="caption" ref="caption"></Caption>
        </div>
    </div>

</template>

<script>
    import ButtonMagnetic from "./ButtonMagnetic";
    import Verge from 'verge';
    import {TimelineMax, TweenMax} from 'gsap';
    import {Device} from "../utils/Device";
    import {i18n} from '../plugin/i18n';
    import Caption from "./Caption";

    export default {
        name: 'ImageZoomable',
        components: {Caption, ButtonMagnetic},
        props: ['src', 'caption', 'bgPos', 'noZoom', 'containZoom', 'noAppearEffect', 'containDisplay', 'onZoom', 'onUnzoom', 'blackButton'],
        data: function(){
            return {
                TL: new TimelineMax(),
                appearEffect: (this.noAppearEffect !== ""),
                isContainDisplay: (this.containDisplay == true),
            };
        },
        methods: {
            imgPath: function(img){
                return require('../assets/img/'+img);
            },
            zoom: function(){

                this.$emit('zoomed');

                let zoom = this.$refs.zoom;
                let zoom_img = this.$refs.zoom_img;
                let image = this.$refs.image;
                let imageDatas = Verge.rectangle(image);
                console.log(imageDatas);


                this.TL.set(zoom, {
                    left: imageDatas.left,
                    top: imageDatas.top,
                    width: imageDatas.width,
                    height: imageDatas.height,
                });

                if(this.containZoom){
                    this.TL.set(zoom_img, {objectFit: 'contain', objectPosition: 'center center'});
                    this.TL.fromTo(zoom, 1, {opacity: 0, visibility: 'visible'}, {opacity:1});
                } else {
                    this.TL.set(zoom, {visibility: 'visible',opacity: 1});
                }
                this.TL.set(image, {
                    visibility: 'hidden',
                });

                this.TL.to(zoom, 1, {
                    left: 0,
                    top: 0,
                    width: Device.vp.w,
                    height: Device.vp.h,
                    force3D:true,
                    backgroundPosition: 'center center',
                    objectFit: 'center center',
                    ease: Expo.easeInOut,
                });

                // on affiche la caption
                if("caption" in this.$refs){
                    let caption = this.$refs.caption.$el;
                    this.TL.to(caption, 0.5, {
                        delay: 1,
                        yPercent: '-100',
                        ease: Expo.easeInOut,
                    })
                }



            },
            unzoom: function() {


                this.$emit('unzoomed');

                let zoom = this.$refs.zoom;
                let image = this.$refs.image;
                let imageDatas = Verge.rectangle(image);
                let bgPos = '';
                if (this.bgPos === undefined) {
                    bgPos = 'center center';
                } else {
                    bgPos = this.bgPos;
                }

                // on masque la caption
                if("caption" in this.$refs){
                    let caption = this.$refs.caption.$el;
                    this.TL.to(caption, 0.5, {
                        yPercent: 0,
                        ease: Expo.easeInOut,
                    });
                }

                this.TL.to(zoom, 1,
                    {
                        left: imageDatas.left,
                        top: imageDatas.top,
                        width: imageDatas.width,
                        height: imageDatas.height,
                        force3D: true,
                        backgroundPosition: bgPos,
                        ease: Expo.easeInOut,
                    }
                );

                this.TL.set(image, { visibility: 'visible'});
                this.TL.to(zoom, 1, {opacity: 0});
                this.TL.set(zoom, {visibility: 'hidden'});

            }
        }
    };
</script>

<style scoped lang="scss">
    .imageZoomable{
        height: 100%;
        width: 100%;
        position: relative;

        &_img{
            width: 100%;
            height: 100%;
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;

            img{
                object-fit: cover;
                object-position: center center;
                width: 100%;
                height: 100%;
            }

            &.containDisplay {
                background-size: contain;
            }
        }

        &_zoom{
            position: fixed;
            visibility: hidden;
            background-color: #fff;
            z-index: 5;
            overflow: hidden;

            img{
                object-fit: cover;
                width: 100%;
                height: 100%;
                margin: 0 auto;
            }
        }

        .buttonMagnetic{
            position: absolute;
            right: $G-default;
            bottom: $G-default;
        }


        .caption{
            position: absolute;
            bottom: 0;
            right: 0;
            transform: translateY(100%);
        }
    }
</style>